import { useMutation } from '@apollo/client';
import { useTranslations } from '@vocab/react';

import { ErrorMessage } from 'src/components/ErrorMessage/ErrorMessage';
import { JobItemLayout } from 'src/components/JobItemLayout/JobItemLayout';
import translations from 'src/containers/SavedJobItem/SavedJob.vocab';
import { DELETE_SAVED_JOB } from 'src/containers/SavedJobItem/delete-saved-job.graphql';
import type {
  SavedJob,
  DeleteSavedJobMutation,
  DeleteSavedJobMutationVariables,
} from 'src/types/graphql';

import { logError } from '../../modules/error-logger/browserLog';

export interface Props {
  job: SavedJob;
  index: number;
  openNotes: (id: string) => void;
}

export const SavedJobItem = (props: Props) => {
  const { t } = useTranslations(translations);
  const { index, job } = props;

  const [deleteSavedJob, deleteSavedJobState] = useMutation<
    DeleteSavedJobMutation,
    DeleteSavedJobMutationVariables
  >(DELETE_SAVED_JOB, {
    onError: () => {
      logError({
        type: 'delete-applied-job-error',
        message: 'Unable to remove job',
      });
    },
    refetchQueries: ['GetSavedJobs'], // using the query name will let apollo client to reuse lastest used variables
    awaitRefetchQueries: true,
  });

  return (
    <JobItemLayout
      index={index}
      errorMessage={
        deleteSavedJobState.error ? (
          <ErrorMessage
            index={index}
            errorMessage={t(
              `Sorry, we couldn’t save your changes. Can we try again?`,
            )}
          />
        ) : null
      }
      job={job}
      type="saved"
      deleteMyActivityJob={deleteSavedJob}
      openNotes={props.openNotes}
    />
  );
};
